<template>
	<transition name="fade" appear>
		<div class="modal" @click="close">
			<slot></slot>
		</div>
	</transition>
</template>

<script>
export default {
	methods: {
		close() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
.modal {
	cursor: pointer;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	background-color: transparentize(black, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
}

.fade-enter-active,
.fade-leave-active {
	transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.fade-enter,
.fade-leave-to {
	transform: translateY(-7px);
	opacity: 0;
}
</style>
